import { useState, useCallback } from 'react';

export const useImagePreload = () => {
  const [isImagePreloading, setIsImagePreloading] = useState(true);
  const [ImagePreloadingError, setImagePreloadingError] = useState<Error | null>(null);

  const preloadImage = useCallback((src: string) => {
    if (!src) {
      setIsImagePreloading(false);
      return;
    }

    return new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        setIsImagePreloading(false);
        resolve();
      };
      img.onerror = (err) => {
        setImagePreloadingError(new Error('Failed to preload image'));
        setIsImagePreloading(false);
        reject(err);
      };
      img.src = src;
    });
  }, []);

  return { isImagePreloading, ImagePreloadingError, preloadImage };
};
